import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Actions } from 'src/store/requests/type-of-property/actions';
import { useBuildType, useLanguageState } from 'src/hooks';
import { Actions as ActionsOfTypes } from 'src/store/type-displayed-spinner/actions';
import { IPlacementType } from 'src/store/type-displayed-spinner/types';
import { IFrontConfigTypeEnum, ISubViewMappingEFloorType } from 'src/typings/table';
import { Actions as View2dActions } from 'src/store/view-2d/actions';

export const useChangeValue = (listOfType: IPlacementType[]) => {
  const dispatch = useDispatch();
  const { isCrossTable } = useBuildType();
  const { currentAppLanguage } = useLanguageState();

  const handleChangeType = useCallback((value: string) => {
    if (value) dispatch(Actions.changeSelectedTypePlacement(value));
    const findingType = listOfType.find((type) => type.title[currentAppLanguage] === value);
    if (findingType) {
      const foundFrontConfig = findingType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website];
      const firstActiveFrontConfig = foundFrontConfig.views.find((view) => view.isEnabled);
      const firstActiveSubViewConfig = firstActiveFrontConfig?.subViews?.find((subView) => subView.isEnabled);
      dispatch(ActionsOfTypes.setTypeDisplayedSpinner(firstActiveFrontConfig?.type));
      if (firstActiveSubViewConfig?.type) {
        dispatch(View2dActions.setFloorItemType(ISubViewMappingEFloorType[firstActiveSubViewConfig.type]));
      }
    }
  }, [dispatch, currentAppLanguage, listOfType, isCrossTable]);

  return {
    handleChangeType,
  };
};
